import { useSearchParams } from 'react-router-dom';
import { Tabs } from '../../ui/Tabs';
import { IntegrationStatusBar } from '../IntegrationStatusBar';
import { VisitorsBlock } from './VisitorsBlock';
import { SearchBlock } from './SearchBlock';
import { BusinessBlock } from './BusinessBlock';
import { SocialBlock } from './SocialBlock';
import { MailBlock } from './MailBlock';
import type { PeriodState } from '../../sales/usePeriodParams';
const parts = [{
  key: 'bezoekers',
  label: 'Bezoekers'
}, {
  key: 'google',
  label: 'Google'
}, {
  key: 'instagram',
  label: 'Instagram'
}, {
  key: 'mail',
  label: 'Nieuwsbrief & mails'
}] as const;
type PartKey = (typeof parts)[number]['key'];

/**
 * Bereik: alles wat van buiten komt (Umami, Google, Instagram, Brevo). Eén bron tegelijk,
 * zodat het scherm niet één lange lijst grafieken wordt. Bovenaan de stand van de koppelingen.
 */
export function ReachTab({
  period
}: {
  period: PeriodState;
}) {
  const [params, setParams] = useSearchParams();
  const part: PartKey = parts.find(p => p.key === params.get('bereik'))?.key ?? 'bezoekers';
  const setPart = (key: PartKey) => setParams(prev => {
    const p = new URLSearchParams(prev);
    p.set('bereik', key);
    return p;
  }, {
    replace: true
  });
  return <div className="space-y-6" data-id="element-1885" data-mp="oe0nygslqzik">
      <div className="flex flex-col gap-4" data-id="element-1886" data-mp="oettxfjqlkzn">
        <Tabs variant="pill" label="Bron" tabs={parts} value={part} onChange={setPart} data-id="element-1887" data-mp="og51zrk7tewk" />
        <IntegrationStatusBar data-id="element-1888" data-mp="1m0zletr4cbhi" />
      </div>
      {part === 'bezoekers' && <VisitorsBlock period={period} data-id="element-1889" data-mp="1h3r2gqy5c3f7" />}
      {part === 'google' && <div className="space-y-10" data-id="element-1890" data-mp="1cbpvnkjqz4wk">
          <SearchBlock period={period} data-id="element-1891" data-mp="1caohv8bck4b5" />
          <BusinessBlock period={period} data-id="element-1892" data-mp="1c9mvw8sslxen" />
        </div>}
      {part === 'instagram' && <SocialBlock period={period} data-id="element-1893" data-mp="17asdh7yqmav2" />}
      {part === 'mail' && <MailBlock period={period} data-id="element-1894" data-mp="24tbxi87kqr4u" />}
    </div>;
}